import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgramPipe } from './program.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [ProgramPipe],
    providers: [ProgramPipe],
    exports: [ProgramPipe],
})
export class ProgramPipeModule {}
